<div class="modal-header">
    <h2 class="modal-title font-weight-bold" id="clientName" *ngIf="client">
        {{ "SUPER-ADMIN.CLIENT.MODALS.UPDATE-CLIENT.TITLE" | translate }} <h4>{{client?.name}}</h4>
    </h2>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('')">
        <span aria-hidden="true">&times;</span>
    </button>    
</div>

<div class="modal-body">
    <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
    <form *ngIf="client" [formGroup]="clientUpdateForm" novalidate #formDirective="ngForm" (ngSubmit)="updateClient(clientUpdateForm.value)">
        <div class='form-row mb-3 my-row'>
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'SUPER-ADMIN.CLIENT.FORM.REFERENCE' | translate }}" formControlName="referenceNumber" id="referenceNumber">
                </mat-form-field>
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'SUPER-ADMIN.CLIENT.FORM.URL' | translate }}" formControlName="url" id="url">
                </mat-form-field>
            </div>
        </div>

        <div class="form-row my-row">
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <div class="form-check form-switch mx-2">
                    <input class="form-check-input" type="checkbox" id="directory" formControlName="directory">
                    <label class="form-check-label" for="directory">{{ "SUPER-ADMIN.CLIENT.FORM.DIRECTORY" | translate }}</label>
                </div>
            </div>
        </div>

        <div class="form-row my-row">
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <div class="form-check form-switch mx-2">
                    <input class="form-check-input" type="checkbox" id="cgu_mml" formControlName="cgu_mml">
                    <label class="form-check-label" for="cgu_mml">{{ "SUPER-ADMIN.CLIENT.FORM.CGU-MML" | translate }}</label>
                </div>
            </div>
        </div>
        
        <div class="form-row my-row">
            <div class='col-6 col-lg-auto pb-3 my-col' *ngIf="client.template">
                <label class="mx-2">{{ 'SUPER-ADMIN.CLIENT.FORM.TEMPLATE' | translate }} <h6>{{client.template.name}}</h6></label>
            </div>

            <div class='col-6 col-lg-auto pb-3 my-col'>
                <label class="mx-2">
                    {{ 'SUPER-ADMIN.CLIENT.FORM.OTP' | translate }}
                    <h6>{{ 'SUPER-ADMIN.CLIENT.FORM.OTP-' + client.otp | uppercase | translate}}</h6>
                </label>
            </div>
        </div>

        <div class="form-row my-row border-bottom">
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <label class="mx-2">{{ 'SUPER-ADMIN.CLIENT.FORM.NBUSER' | translate }} <h6>{{client.nbUser}}</h6></label>
            </div>
        </div>

        <div class='form-row pt-3 my-row'>
            <div class='col my-col'>
                <button type="submit" class="btn btn-primary mx-1" [disabled]="!clientUpdateForm.valid">{{ "BUTTONS.UPDATE" | translate }}</button>
                <button type="button" class="btn btn-danger" (click)="activeModal.close('')">{{ "BUTTONS.CLOSE" | translate }}</button>
            </div>
        </div>
    </form>
</div>